<mat-expansion-panel [expanded]="true" #panel  class="mat-elevation-z8">
  <mat-expansion-panel-header>
    <mat-panel-title>      
      Data
    </mat-panel-title>
    <mat-panel-description>
      Result of executing the SQL query which represents content of DynamoSQL
    </mat-panel-description>
  </mat-expansion-panel-header> 
<mat-table mat-table [dataSource]="content">
    <ng-container *ngFor="let col of getColumns()" [matColumnDef]="col">
        <mat-header-cell *matHeaderCellDef>{{col}}</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element[col]}}</mat-cell>
      </ng-container>
    <mat-header-row  *matHeaderRowDef="getColumns()"></mat-header-row >
    <mat-row *matRowDef="let row; columns: getColumns();">        
    </mat-row>
</mat-table>
</mat-expansion-panel>